/*
 * Copyright (c) All right reserved Anvish Inc. 2025
 * This project and any portion thereof may not be reproduced or used in any manner without the express written permission of Anvish Inc.
 */

"use client";
import { useEffect } from "react";

const SetTheme = () => {
  useEffect(() => {
    localStorage.theme = "light";
  }, []);

  return null;
};

export default SetTheme;
